import { FC, useEffect } from 'react';
import { useIntl } from 'react-intl';

import { demoBasePath, trackEvent } from '@/shared/lib';
import { Button, Layout } from '@/shared/ui/';

import { GetFullAccessModal } from '@/widgets/GetFullAccessModal';
import { Header } from '@/widgets/Header';

import styles from './ErrorPage.module.scss';

export const ErrorPage: FC = () => {
  const { formatMessage } = useIntl();

  useEffect(() => {
    trackEvent({
      eventName: 'ErrorPage Page Viewed',
      isPageViewEvent: true,
    });
  }, []);

  return (
    <Layout>
      <Layout.Header>
        <Header />
      </Layout.Header>
      <Layout.Content data-section="error-page">
        <Layout.Main>
          <div className={styles.container}>
            <div className={styles.content}>
              <div className={styles.logo} />
              {/* TODO: change to intl node after integration */}
              <p className={styles.text}>
                {formatMessage({
                  id: 'errorPage.somethingWentWrong',
                  defaultMessage: 'Oops. Something went wrong',
                })}
              </p>
              <Button
                variant="secondary"
                onClick={() => window.location.replace(demoBasePath() || '/')}
                className={styles.button}
              >
                {formatMessage({
                  id: 'errorPage.goToHomePage',
                  defaultMessage: 'Go to home page',
                })}
              </Button>
            </div>
          </div>
        </Layout.Main>
      </Layout.Content>

      <GetFullAccessModal />
    </Layout>
  );
};
